import React, { useEffect } from 'react'
import { Button, Snackbar } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { handleRedirectInternal } from '@/product/common/components'
import TabPanelComp from '@/views/Home/TabPanelComp'
import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import './AuctionsList.css'
import authContext from '@/product/context/auth/authContext'
import { useContext } from 'react'
import { Alert } from '@material-ui/lab'
import CustomCommonContext from '@/custom/context/common/commonContext'
import Faq from '../Static/FAQ'
const AuctionsList = () => {
    const history = useHistory()
    const auth = useContext(authContext)
    const { user, isAuthenticated } = auth
    const [open, setOpen] = React.useState(false)
    const customCommonContext = useContext(CustomCommonContext)
    const { alldata_all_dropdown, getCount, statics_count } = customCommonContext
    const [staticData, setStatic] = React.useState({
        auction_count: 9494,
        bidderss_count: 3011,
        users_count: 95017,
        projects_count: 33524,
    })
    const handlePartnerClick = () => {
        if (isAuthenticated) {
            setOpen(true)
        } else {
            setOpen(true)
        }
    }
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return
        }
        setOpen(false)
    }
    useEffect(() => {
        getCount()
    }, [])
    useEffect(() => {
        if (statics_count?.record && statics_count?.record[0]) {
            console.log('11111111111111', statics_count)
            setStatic(statics_count?.record[0])
        }
    }, [statics_count])
    const financeFormik = useFormik({
        initialValues: {
            full_name: '',
            mob_no: '',
            email: '',
            location: '',
        },

        onSubmit: (values) => {
            console.log('values', values)
        },
    })

    const valuationFormik = useFormik({
        initialValues: {
            full_name: '',
            mob_no: '',
            email: '',
            location: '',
        },

        onSubmit: (values) => {
            console.log('values', values)
        },
    })

    const financeFields = {
        formik: financeFormik,
        data: [
            {
                name: 'full_name',
                label: 'Full Name',
                type: 'text',
                placeholder: 'Enter your full name',
                required: true,
            },
            {
                name: 'mob_no',
                label: 'Mobile Number',
                type: 'text',
                placeholder: 'Enter your mobile number',
                required: true,
            },
            {
                name: 'email',
                label: 'Email ID',
                type: 'email',
                placeholder: 'Enter your email id',
                required: true,
            },
            {
                name: 'location',
                label: 'Location',
                type: 'text',
                placeholder: 'Enter your location',
                required: true,
            },
        ],
    }

    const valuationFields = {
        formik: valuationFormik,
        data: [
            {
                name: 'full_name',
                label: 'Full Name',
                type: 'text',
                placeholder: 'Enter your full name',
                required: true,
            },
            {
                name: 'mob_no',
                label: 'Mobile Number',
                type: 'text',
                placeholder: 'Enter your mobile number',
                required: true,
            },
            {
                name: 'email',
                label: 'Email ID',
                type: 'email',
                placeholder: 'Enter your email id',
                required: true,
            },
            {
                name: 'location',
                label: 'Location',
                type: 'text',
                placeholder: 'Enter your location',
                required: true,
            },
        ],
    }
    const smoothScrollTo = (selector) => {
        const element = document.querySelector(selector)
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' })
        }
    }
    return (
        <div className="listContainer">
            <section>
                <div className="auctionListBanner">
                    <div className="auctionListBannerContent">
                        <div>
                            <h1>Online Auctions For Various Asset & Inventory Types</h1>
                            <h3>
                                A Full-service Marketplace for Used Construction Equipment,
                                Commercial Vehicles, Farm Equipment, Cars, Scrap, Liquidations and a
                                lot more.
                            </h3>
                            <div className="auctionBannerButtonWrapper mt-4 d-flex justify-content-start">
                                <Button onClick={handlePartnerClick}>Become a Partner</Button>
                                <Button onClick={() => smoothScrollTo('.auctionListContainer')}>
                                    View Auction
                                </Button>
                            </div>
                        </div>
                        <div className="site-header-image">
                            <div className="site-header-image-wrap">
                                <div className="site-header-image-column">
                                    <img
                                        alt=""
                                        className="site-header-animation-wipe"
                                        src="/assets/images/auction-banner-img1.png"
                                    />
                                    <img
                                        alt=""
                                        className="site-header-animation-rotate"
                                        src="/assets/images/auction-banner-img5.png"
                                    />
                                </div>
                                <div className="site-header-image-column">
                                    <img
                                        alt=""
                                        className="site-header-animation-wipe"
                                        src="/assets/images/auction-banner-img4.png"
                                    />
                                    <img
                                        alt=""
                                        className="site-header-animation-rotate"
                                        src="/assets/images/auction-banner-img12.png"
                                    />
                                    <img
                                        alt=""
                                        className="site-header-animation-wipe"
                                        src="/assets/images/auction-banner-img7.png"
                                    />
                                    <img
                                        alt=""
                                        className="site-header-animation-rotate"
                                        src="/assets/images/auction-banner-img8.png"
                                    />
                                </div>
                                <div className="site-header-image-column">
                                    <img
                                        alt=""
                                        className="site-header-animation-rotate"
                                        src="/assets/images/auction-banner-img2.png"
                                    />
                                    <img
                                        alt=""
                                        className="site-header-animation-wipe"
                                        src="/assets/images/auction-banner-img3.png"
                                    />
                                    <img
                                        alt=""
                                        className="site-header-animation-rotate"
                                        src="/assets/images/auction-banner-img11.png"
                                    />
                                    <img
                                        alt=""
                                        className="site-header-animation-wipe"
                                        src="/assets/images/auction-banner-img10.png"
                                    />
                                </div>
                                <div className="site-header-image-column">
                                    <img
                                        alt=""
                                        className="site-header-animation-rotate"
                                        src="/assets/images/auction-banner-img9.png"
                                    />
                                    <img
                                        alt=""
                                        className="site-header-animation-wipe"
                                        src="/assets/images/auction-banner-img6.png"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Snackbar
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}
                className={isAuthenticated ? 'snackbarContainer' : 'adminSnackbarContainer'}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    elevation={6}
                    variant="filled"
                    onClose={handleClose}
                    severity={isAuthenticated ? 'info' : 'warning'}
                >
                    {isAuthenticated
                        ? 'You are already our registered Partner.'
                        : ' Please contact admin to become a partner.'}
                </Alert>
            </Snackbar>
            <section className="welcomeSection">
                <div className="welcomeParent d-flex align-items-center justify-content-between">
                    <div className="wlcmContentContent">
                        <h2>Welcome to</h2>
                        <h1>Iquippo Auctions</h1>
                    </div>
                    <div className="wlcmContentBox d-flex align-items-center justify-content-between">
                        <div className="firstCol boxParent d-flex flex-column align-items-center justify-content-center">
                            <div
                                onClick={() => handleRedirectInternal(history, 'login')}
                                className="boxContainer d-flex flex-column align-items-center justify-content-center"
                            >
                                <img src="/assets/images/welcomeImage/icon-add-user.svg" />
                                <span>Login/Register</span>
                            </div>
                            <div
                                onClick={() => handleRedirectInternal(history, 'login')}
                                className="boxContainer d-flex flex-column align-items-center justify-content-center"
                            >
                                <img src="/assets/images/welcomeImage/icon-auction-list.svg" />
                                <span>Register in Auction</span>
                            </div>
                        </div>
                        <div className="secondCol boxParent d-flex flex-column align-items-center justify-content-center">
                            <div
                                onClick={() => handleRedirectInternal(history, 'login')}
                                className="boxContainer d-flex flex-column align-items-center justify-content-center"
                            >
                                <img src="/assets/images/welcomeImage/icon-user-kyc.svg" />
                                <span>Submit Kyc</span>
                            </div>
                            <div
                                onClick={() => handleRedirectInternal(history, 'login')}
                                className="boxContainer d-flex flex-column align-items-center justify-content-center"
                            >
                                <img src="/assets/images/welcomeImage/icon-bidding.svg" />
                                <span>Start Bidding</span>
                            </div>
                        </div>
                        <div className="thirdCol boxParent d-flex flex-column align-items-center justify-content-center">
                            <div
                                onClick={() => handleRedirectInternal(history, 'search')}
                                className="boxContainer d-flex flex-column align-items-center justify-content-center"
                            >
                                <img src="/assets/images/welcomeImage/icon-browsing.svg" />
                                <span>Browse Inventory</span>
                            </div>
                            <div
                                onClick={() => handleRedirectInternal(history, 'login')}
                                className="boxContainer d-flex flex-column align-items-center justify-content-center"
                            >
                                <img src="/assets/images/welcomeImage/icon-refund.svg" />
                                <span>Easy Refund</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="auctionListContainer">
                <TabPanelComp home={true} auctionsList={'list'} />
            </section>

            <section className="listNumSection">
                <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                    <div className="listNumParent d-flex align-items-center justify-content-between">
                        <div className="listNumCol d-flex flex-column align-items-center justify-content-center">
                            <div className="d-flex flex-column align-items-center">
                                <h1>{staticData.auction_count}</h1>
                                <h3>Number of Auctions</h3>
                            </div>
                            <div className="d-flex flex-column align-items-center">
                                <h1>{staticData.users_count}</h1>
                                <h3>Customer Base</h3>
                            </div>
                        </div>
                        <div className="listNumCol d-flex flex-column align-items-center justify-content-center">
                            <div className="d-flex flex-column align-items-center">
                                <h1>{staticData.bidders_count}</h1>
                                <h3>Total Bidders</h3>
                            </div>
                            <div className="d-flex flex-column align-items-center">
                                <h1>{staticData.projects_count}</h1>
                                <h3>Total Asset Listed</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* 
            <section className="listAuctionForm">
                <div className="listAuctionFormParent">
                    <div className="aucFormParent">
                        <div className="financeForm">
                            <div className="mb-3">
                                <h3>Financing with iQuippo</h3>
                                <h5>Get the best offer from multiple banks</h5>
                            </div>
                            <form onSubmit={financeFormik.handleSubmit}>
                                {mapData(financeFields)}
                                <Button type="submit">Get the Offer</Button>
                            </form>
                        </div>
                        <div className="d-flex align-items-center justify-content-center">
                            <div className="dashedLine"></div>
                        </div>

                        <div className="financeForm">
                            <div className="mb-3">
                                <h3>Valuation Report</h3>
                                <h5>Get Right Value Of Used Equipment, Instantly</h5>
                            </div>
                            <form onSubmit={valuationFormik.handleSubmit}>
                                {mapData(financeFields)}
                                <Button type="submit">Get the Valuation Report</Button>
                            </form>
                        </div>
                    </div>
                    <div className="dashedCompBox">
                        <h3>Single Platform, Multiple Banks</h3>
                        <div className="listBankCntParent">
                            <div>
                                <img src="/assets/images/bank/axisBank.png" />
                            </div>
                            <div>
                                <img src="/assets/images/bank/iciciBank.png" />
                            </div>
                            <div>
                                <img src="/assets/images/bank/indusBank.png" />
                            </div>
                            <div>
                                <img src="/assets/images/bank/yesyBank.png" />
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            <section className="sectionContainer customContainer">
                <div className="childContainer px-0 pb-0">
                    <div
                        className="childHeader d-flex justify-content-between align-items-center"
                        style={{ padding: '0px 24px 12px 24px' }}
                    >
                        <h3 className="mb-0">Frequently Asked Questions on Assets</h3>
                    </div>

                    <Faq />
                </div>
            </section>
        </div>
    )
}

export default AuctionsList
